import { Texto, Vertical } from '@gravitate-js/excalibrr'
import type { Ratebook } from '@api/useFreight/types'

interface HeaderProps {
  ratebook: Ratebook
}

export function RatebookHeader({ ratebook }: HeaderProps) {
  const name = ratebook.counterparty_name

  // Format the address from address_info fields if available, or fall back to the simple address field
  const formatAddressForDisplay = () => {
    if (ratebook.address_info) {
      const { address, city, state, postal_code } = ratebook.address_info
      const parts = []

      if (address) parts.push(address)
      if (city && state) parts.push(`${city}, ${state}`)
      else if (city) parts.push(city)
      else if (state) parts.push(state)
      if (postal_code) parts.push(postal_code)

      return parts.length > 0 ? parts.join(', ') : 'No address available'
    }

    return ratebook.address || 'No address available'
  }

  const formattedAddress = formatAddressForDisplay()

  return (
    <Vertical flex={1}>
      <Texto category='h4'>{name}</Texto>
      <Texto appearance='hint'>{formattedAddress}</Texto>
    </Vertical>
  )
}
